// GiftCardsPage.js
import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import GiftSessionWizard from "./GiftSessionWizard";
import SEO from "./SEO";
import "./GiftCardsPage.css";

const GiftCardsPage = () => {
  const location = useLocation();
  const [activeTab, setActiveTab] = useState(
    location.hash === "#gift-sessions" ? "sessions" : "cards"
  );

  useEffect(() => {
    // Update URL hash when tab changes
    window.history.replaceState(
      null,
      "",
      activeTab === "sessions" ? "#gift-sessions" : "#gift-cards"
    );

    // Only load Gift Up script when on the gift cards tab
    if (activeTab === "cards") {
      const script = document.createElement("script");
      script.src = "https://cdn.giftup.app/dist/gift-up.js";
      script.async = true;
      document.body.appendChild(script);

      // Cleanup on unmount or tab change
      return () => {
        if (document.body.contains(script)) {
          document.body.removeChild(script);
        }
      };
    }
  }, [activeTab]);

  return (
    <div className="gift-cards-page">
      <SEO
        title="Gift Cards & Gift Sessions | Diviti Adora Wellness Studio | Oro Valley AZ"
        description="Give the gift of wellness with Diviti Adora gift cards and gift sessions. Choose between infrared sauna or red light therapy sessions for your loved ones in Oro Valley, Tucson, and Marana."
        keywords="gift cards, wellness gift, gift sessions, infrared sauna gift, red light therapy gift, wellness present, Oro Valley gift, spa gift, infrared sauna Oro Valley AZ, red light therapy near Oro Valley, wellness center Tucson Arizona, holistic healing Oro Valley, self-care spa Oro Valley, alternative wellness center Tucson, health and wellness studio Marana"
        canonicalUrl="/gift-cards"
      />
      <header className="gift-cards-header">
        <h1>Gift Cards & Gift Sessions</h1>
        <p>
          Give the gift of wellness with our gift cards and special gift
          sessions.
        </p>
      </header>

      <div className="gift-tabs">
        <button
          className={`gift-tab ${activeTab === "cards" ? "active" : ""}`}
          onClick={() => setActiveTab("cards")}
        >
          Gift Cards
        </button>
        <button
          className={`gift-tab ${activeTab === "sessions" ? "active" : ""}`}
          onClick={() => setActiveTab("sessions")}
        >
          Gift Sessions
        </button>
      </div>

      <section className="gift-cards-content">
        {activeTab === "cards" ? (
          <>
            <div className="gift-cards-description">
              <h2>Gift Cards</h2>
              <p>
                Purchase a gift card for any amount. The recipient can use it
                towards any service or product at our studio.
              </p>
            </div>
            {/* Gift Up widget target */}
            <div
              className="gift-up-target"
              data-site-id="79d5bc4a-753f-4fd1-cc2d-08dd62e94d87"
              data-platform="Other"
              data-language="en-US"
              data-payment-methods="Stripe"
            ></div>
          </>
        ) : (
          <>
            <div className="gift-sessions-description">
              <h2>Gift Sessions</h2>
              <p>
                Gift specific sessions to friends and family. Choose between
                infrared sauna or red light therapy sessions.
              </p>
            </div>
            <GiftSessionWizard />
          </>
        )}
      </section>
    </div>
  );
};

export default GiftCardsPage;
